import { SettingsSection } from '@components'

import { useTranslation } from 'react-i18next'

import { EInvoicingSettings } from '@features/eInvoicingSettings'

export const OrganizationEInvoiceSettings = () => {
  const { t } = useTranslation()
  return (
    <SettingsSection>
      <SettingsSection.Content title={t('einvoicing.settings.settings_title')}>
        <EInvoicingSettings context="Organization" />
      </SettingsSection.Content>
    </SettingsSection>
  )
}
